import {HttpClient} from "../../http/HttpClient.jsx";
import {message} from "antd";

const createBaseMeFinanceContact = (me, financeContact) => {
    return {
        businessNumber: financeContact?.businessNumber,
        financeContact: {
            name: financeContact?.name,
            email: financeContact?.email,
            phone: financeContact?.phone,
            companyNameForInvoice: financeContact?.companyNameForInvoice
        },
        ...(me?.isCompanyMaster
            ? {
                  requirePONumber: !!financeContact?.requirePONumber,
                  separateSubAdminInvoices: !!financeContact?.separateSubAdminInvoices
              }
            : {})
    };
};

export const updateMeCompanyFinanceContact = async (me, financeContact) => {
    const updateCompanyFinanceContactRequest = await HttpClient.safePost(
        "/api/companies/me/updateCompanyFinanceContact",
        createBaseMeFinanceContact(me, financeContact)
    );

    if (updateCompanyFinanceContactRequest?.error) {
        message.error("שגיאה בעת עידכון המידע החשבונאי של החברה");
    } else {
        message.success("המידע החשבונאי עודכן בהצלחה");
    }

    return updateCompanyFinanceContactRequest;
};

export const updateCompanyFinanceContact = async (me, financeContact) => {
    const updateCompanyFinanceContactRequest = await HttpClient.safePost(
        `/api/companies/${me?.userId}/updateCompanyFinanceContact`,
        createBaseMeFinanceContact(me, financeContact)
    );

    if (updateCompanyFinanceContactRequest?.error) {
        message.error("שגיאה בעת עידכון המידע החשבונאי של החברה");
    } else {
        message.success("המידע החשבונאי עודכן בהצלחה");
    }

    return updateCompanyFinanceContactRequest;
};
